import { AlertTypes } from "@/helpers/enums/AlertTypes";
import { Roles } from "@/helpers/enums/Roles";

const data = {
  card1: {
    filter: {
      title: "filter",
      pageName: "filter",
      genre: "filter",
      hideFilter: true,
      ignoreSaveFilter: true,
      filters: [],
    },
    header: {
      navigation: [
        {
          title: "securityalerts",
          url: "configuration/security-alerts",
          activeUrl: "security-alerts",
          slot: "security-alerts",
          hideRoles: [Roles.AGMSAdmin],
        },
        {
          title: "liveSiteAlert",
          url: "configuration/live-site-alerts",
          activeUrl: "live-site-alerts",
          slot: "live-site-alerts",
          hideRoles: [
            Roles.PartnerAdmin,
            Roles.CompanyAdmin,
            Roles.GroupAdmin,
            Roles.GroupAudit,
            Roles.SiteAdmin,
            Roles.SiteAudit,
          ],
        },
        {
          title: "deploymentHealthAlert",
          url: "configuration/deployment-health-alerts",
          activeUrl: "deployment-health-alerts",
          slot: "deployment-health-alerts",
          hideRoles: [Roles.AGMSAdmin],
        },
        // {
        //   title: "systemalerts",
        //   url: "configuration/system-alerts",
        //   activeUrl: "system-alerts",
        //   slot: "system-alerts",
        //   hideRoles: [
        //     Roles.CompanyAdmin,
        //     Roles.GroupAdmin,
        //     Roles.GroupAudit,
        //     Roles.SiteAdmin,
        //     Roles.SiteAudit,
        //   ],
        // },
      ],
      buttonPosition: "justify-content-between",
      buttons: [
        {
          title: "alertList",
          icon: "alert",
          class: "primary mr-3",
          link: "/alert-console/all",
          target: "",
          toggle: "",
        },
      ],
    },
    component: {
      type: "custom",
      options: {},
    },
  },
  securityalerts: {
    filter: {
      title: "filter",
      pageName: "filter",
      genre: "filter",
      ignoreSaveFilter: true,
      hideFilter: true,
      filters: [],
    },
    header: {},
    component: {
      type: "ag-table",
      options: {
        columns: [
          {
            label: "alerttype",
            field: "alarmType",
            sortable: false,
            display: function (row: any, t: any) {
              return (
                '<span class="p-1 ag-ribbon ag-ribbon_' +
                AlertTypes[row.alarmType] +
                '">' +
                t(AlertTypes[row.alarmType]) +
                "</span>"
              );
            },
          },
          {
            label: "category",
            field: "alarmCateogryLabel",
            sortable: false,
          },
          {
            label: "status",
            sortable: false,
            components: [
              {
                component: "tableToggle",
                field: "condition",
              },
            ],
          },
          {
            label: "action",
            sortable: false,
            display: function (row: any, t: any) {
              return row.emails;
            },
          },
          {
            label: "condition",
            field: "conditionJson",
            sortable: false,
            display: function (row: any) {
              const parsed: any = JSON.parse(row.conditionJson);
              switch (row.alarmCateogryLabel) {
                case "New Hash Seen":
                  if (!parsed) return "Data Error";
                  else
                    return (
                      "<div style='display:inline !important'>New <strong>" +
                      parsed[0].DefaultValue.replace("Hash ", "") +
                      " Hash</strong> is Reported </div>"
                    );
                  break;
                  
                case "New Hash Reported":
                  if (!parsed) return "Data Error";
                  else
                    return (
                      "<div style='display:inline !important'>New <strong>" +
                      parsed[0].DefaultValue.replace("Hash ", "") +
                      " Hash</strong> is Reported </div>"
                    );
                  break;

                case "High Event Volume: Critical Severity":
                  if (!parsed || parsed.length < 2) return "Data Error";
                  else
                    return (
                      "<div style='display:inline !important'>More Than <strong>" +
                      parsed[0].DefaultValue +
                      "</strong> Critical Event" +
                      (parsed[0].DefaultValue > 1 ? "s" : "") +
                      " in <strong>" +
                      parsed[1].DefaultValue +
                      " Day" +
                      (parsed[1].DefaultValue > 1 ? "s" : "") +
                      "</strong> </div>"
                    );
                  break;

                case "High Event Volume: Block Events by Type":
                  if (!parsed || parsed.length < 3) return "Data Error";
                  else
                    return (
                      "<div style='display:inline !important'>More Than <strong>" +
                      parsed[2].DefaultValue +
                      " " +
                      parsed[0].DefaultValue +
                      "</strong> Event" +
                      (parsed[2].DefaultValue > 1 ? "s" : "") +
                      " in<strong style='padding:0 5px;'>" +
                      JSON.parse(row.conditionJson)[1].DefaultValue +
                      " Day" +
                      (parsed[1].DefaultValue > 1 ? "s" : "") +
                      "</strong> </div> "
                    );
                  break;

                case "Event Volume on a Single Endpoint":
                  if (!parsed || parsed.length < 2) return "Data Error";
                  else
                    return (
                      "<div style='display:inline !important'>More Than <strong>" +
                      parsed[0].DefaultValue.replace("Hash ", "") +
                      "</strong> Event" +
                      (parsed[0].DefaultValue > 1 ? "s" : "") +
                      " in<strong style='padding:0 5px;'>" +
                      JSON.parse(row.conditionJson)[1].DefaultValue +
                      "</strong> Day" +
                      (parsed[1].DefaultValue > 1 ? "s" : "") +
                      " </div>"
                    );
                  break;

                default:
                  return "Parse Error";
              }

              return JSON.stringify(row);
            },
          },
          {
            label: "",
            field: "edit",
            width: "100px",
            components: [
              // {
              //   component: "tableEditComponent",
              //   target: "#alertFormModal",
              //   class: "editBtn",
              // },
              {
                component: "tableDeleteComponent",
                class: "mr-2 ml-2",
              },
            ],
          },
        ],
        rows: [],
        total: 0,
        sortable: {
          order: "alerttype",
          sort: "asc",
        },
        page: 1,
        pageSize: 50,
        isLoading: false,
        fetchTable: (options: any) => {
          console.log(options);
        },
      },
    },
  },
  systemalerts: {
    filter: {
      title: "filter",
      pageName: "filter",
      genre: "filter",
      ignoreSaveFilter: true,
      hideFilter: true,
      filters: [],
    },
    header: {},
    component: {
      type: "ag-table",
      options: {
        columns: [
          {
            label: "alerttype",
            field: "alarmType",
            sortable: false,
            display: function (row: any, t: any) {
              return (
                '<span class="p-1 ag-ribbon ag-ribbon_' +
                AlertTypes[row.alarmType] +
                '">' +
                t(AlertTypes[row.alarmType]) +
                "</span>"
              );
            },
          },
          {
            label: "category",
            field: "alarmCateogryLabel",
            sortable: false,
          },
          {
            label: "status",
            sortable: false,
            components: [
              {
                component: "tableToggle",
                field: "condition",
              },
            ],
          },
          {
            label: "action",
            sortable: false,
            display: function (row: any, t: any) {
              return row.emails;
            },
          },
          {
            label: "condition",
            field: "conditionJson",
            sortable: false,
            display: function (row: any) {
              let parsed: any = null;
              try {
                parsed = JSON.parse(row.conditionJson)[0];
              } catch (e) {
                console.log("parse error", e);
              }
              // eslint-disable-next-line
              let descriptionText =
                "<strong>" + parsed.DefaultValue + "</strong>% Percent";
              switch (row.alarmCateogryLabel) {
                case "Critical CPU Usage":
                  descriptionText =
                    "<div style='display:inline !important'>CPU Usage is Above <strong> " +
                    parsed.DefaultValue +
                    "</strong>%</div>";
                  break;
                case "Critical Disk Usage":
                  descriptionText =
                    "<div style='display:inline !important'>Disk Usage is Above <strong> " +
                    parsed.DefaultValue +
                    "</strong>%</div>";
                  break;
                case "Critical Memory Usage":
                  descriptionText =
                    "<div style='display:inline !important'>Memory Usage is Above <strong> " +
                    parsed.DefaultValue +
                    "</strong>%</div>";
                  break;
                default:
                  break;
              }

              return descriptionText;
            },
          },
          {
            label: "",
            field: "edit",
            width: "100px",
            components: [
              // {
              //   component: "tableEditComponent",
              //   target: "#alertFormModal",
              //   class: "editBtn",
              // },
              {
                component: "tableDeleteComponent",
                class: "mr-2 ml-2",
                roles: [Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin],
              },
            ],
          },
        ],
        rows: [],
        total: 0,
        sortable: {
          order: "alerttype",
          sort: "asc",
        },
        page: 1,
        pageSize: 50,
        isLoading: false,
        fetchTable: (options: any) => {
          console.log(options);
        },
      },
    },
  },
  liveSiteAlert: {
    filter: {
      title: "filter",
      pageName: "filter",
      genre: "filter",
      ignoreSaveFilter: true,
      hideFilter: true,
      filters: [],
    },
    header: {},
    component: {
      type: "ag-table",
      options: {
        columns: [
          {
            label: "alerttype",
            field: "alarmType",
            sortable: false,
            display: function (row: any, t: any) {
              return (
                '<span class="p-1 ag-ribbon ag-ribbon_' +
                AlertTypes[row.alarmType] +
                '">' +
                t(AlertTypes[row.alarmType]) +
                "</span>"
              );
            },
          },
          {
            label: "category",
            field: "alarmCateogryLabel",
            sortable: false,
          },
          {
            label: "status",
            sortable: false,
            components: [
              {
                component: "tableToggle",
                field: "condition",
              },
            ],
          },
          {
            label: "action",
            sortable: false,
            display: function (row: any, t: any) {
              return row.emails;
            },
          },
          {
            label: "condition",
            field: "conditionJson",
            sortable: false,
            display: function (row: any) {
              const parsed: any = JSON.parse(row.conditionJson)[0];

              switch (row.alarmCateogryLabel) {
                case "Middleware Exceptions":
                  return (
                    "<div style='display:inline !important'><strong>" +
                    parsed.DefaultValue +
                    "</strong> Middleware Exceptions </div>"
                  );
                  break;
                case "Agent Status":
                  return (
                    "<div style='display:inline !important'>Agent has <strong>" +
                    parsed.DefaultValue +
                    "</strong></div>"
                  );
                  break;
                case "Rest Relay File Load":
                  return (
                    "<div style='display:inline !important'>Number of Logs Waiting for Processing is more than  <strong>" +
                    parsed.DefaultValue +
                    "</strong></div>"
                  );
                  break;
                case "RabbitMQ Queue":
                  return (
                    "<div style='display:inline !important'>Number of Messages Waiting for Delivery is more <strong>" +
                    parsed.DefaultValue +
                    "</strong></div>"
                  );
                  break;
                case "Corrupted File":
                  return "File is not Processed by LRS";
                  break;
              }
            },
          },
          {
            label: "",
            field: "edit",
            width: "100px",
            components: [
              // {
              //   component: "tableEditComponent",
              //   target: "#alertFormModal",
              //   class: "editBtn",
              // },
              {
                component: "tableDeleteComponent",
                class: "mr-2 ml-2",
              },
            ],
          },
        ],
        rows: [],
        total: 0,
        sortable: {
          order: "alerttype",
          sort: "asc",
        },
        page: 1,
        pageSize: 50,
        isLoading: false,
        fetchTable: (options: any) => {
          console.log(options);
        },
      },
    },
  },
  deploymentHealthAlerts: {
    filter: {
      title: "filter",
      pageName: "filter",
      genre: "filter",
      ignoreSaveFilter: true,
      hideFilter: true,
      filters: [],
    },
    header: {},
    component: {
      type: "ag-table",
      options: {
        columns: [
          {
            label: "alerttype",
            field: "alarmType",
            sortable: false,
            display: function (row: any, t: any) {
              return (
                '<span class="p-1 ag-ribbon ag-ribbon_' +
                AlertTypes[row.alarmType] +
                '">' +
                t(AlertTypes[row.alarmType]) +
                "</span>"
              );
            },
          },
          {
            label: "category",
            field: "alarmCateogryLabel",
            sortable: false,
          },
          {
            label: "status",
            sortable: false,
            components: [
              {
                component: "tableToggle",
                field: "condition",
              },
            ],
          },
          {
            label: "action",
            sortable: false,
            display: function (row: any, t: any) {
              return row.emails;
            },
          },
          {
            label: "condition",
            field: "conditionJson",
            sortable: false,
            display: function (row: any) {
              const parsed: any = JSON.parse(row.conditionJson);
              switch (row.alarmCateogryLabel) {
                case "Endpoint Population: % that haven’t reported for N days":
                  return (
                    "<div style='display:inline !important'><strong>" +
                    parsed[0].DefaultValue +
                    "%</strong> of active endpoints haven’t reported  for <strong>" +
                    parsed[1].DefaultValue +
                    "</strong> Days " +
                    " </div>"
                  );
                  break;
              }
            },
          },
          {
            label: "",
            field: "edit",
            width: "100px",
            components: [
              // {
              //   component: "tableEditComponent",
              //   target: "#alertFormModal",
              //   class: "editBtn",
              // },
              {
                component: "tableDeleteComponent",
                class: "mr-2 ml-2",
              },
            ],
          },
        ],
        rows: [],
        total: 0,
        sortable: {
          order: "alerttype",
          sort: "asc",
        },
        page: 1,
        pageSize: 50,
        isLoading: false,
        fetchTable: (options: any) => {
          console.log(options);
        },
      },
    },
  },
};

export default data;
